import { jwtDecode } from "jwt-decode";
import api from "../../src/utils/api";

const clearAuthStorage = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("username");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("roles");
  localStorage.removeItem("userId");
  localStorage.removeItem("roleId");
  localStorage.removeItem("currentUserId");
  localStorage.removeItem("user");

  sessionStorage.clear();

  document.cookie = "username=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  document.cookie = "authToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
};

// Function to log in a user by making a POST request to the API
export const loginUser = async (username, password) => {
  try {
    // Clear old/expired tokens before a new login attempt
    clearAuthStorage();

    const response = await api.post("/authenticate", { username, password });
    const data = response.data;

    localStorage.setItem("authToken", data.token);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem("username", username);
    localStorage.setItem("firstName", data.firstName);
    localStorage.setItem("lastName", data.lastName);
    localStorage.setItem("roles", JSON.stringify(data.roles || []));
    localStorage.setItem("userId", data.userId);
    localStorage.setItem("roleId", data.roleId);
    localStorage.setItem("currentUserId", data.userId);
    localStorage.setItem("user", JSON.stringify(data));

    return data;
  } catch (error) {
    // Keep the user on the login page
    clearAuthStorage();

    throw new Error(
      error.response?.data?.error || "Invalid username or password"
    );
  }
};

// Function to check if the user is authenticated
export const checkAuthentication = () => {
  const authToken = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const isLoginPage = window.location.pathname === "/login";

  if (!authToken || !refreshToken) {
    if (!isLoginPage) {
      window.location.href = "/login";
    }

    return false;
  }

  try {
    jwtDecode(authToken);
    return true;
  } catch (error) {
    signOut(!isLoginPage);
    return false;
  }
};

// Function to check if the user has the required roles to access a feature
export const checkRole = (requiredRoles) => {
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");
  const hasAccess = roles.some((role) => requiredRoles.includes(role));

  if (!hasAccess) {
    window.location.href = "/unauthorized";
    return false;
  }

  return true;
};

// Function to sign out the user by clearing localStorage
export const signOut = (redirect = true) => {
  clearAuthStorage();

  if (redirect && window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};